import PlainJsStoreORM from 'js/src/data/plain-js-store-orm';
import type { RootState } from 'js/src/libs/RootState';

const NO_NOTIFICATION_IDS: readonly number[] = [];

/* SELECTORS */
export function _selectNotification(state: RootState) {
    return state.notifications;
}

export function selectNotificationsUiState(state: RootState) {
    return _selectNotification(state)?.uiState;
}

export const _selectNotificationList = (state: RootState) => {
    return _selectNotification(state)?.notifications_list;
};

export const selectAllNotificationIds = (state: RootState): readonly number[] => {
    return _selectNotificationList(state)?.allIds ?? NO_NOTIFICATION_IDS;
};

export const selectNotificationById = (state: RootState, notificationId: number) => {
    const notifications = _selectNotificationList(state);
    return notifications ? new PlainJsStoreORM(notifications).getById(notificationId) : undefined;
};

export const selectHasUnreadNotifications = (state: RootState) => {
    return _selectNotification(state)?.has_unread;
};
